export const APP_VERSION = '4.4.0';
export const BUILD_DATE = '2026-03-19';
export const APP_NAME = 'F1 to F12';